module.exports = __webpack_public_path__ + "static/media/solution23.cd9649ff.png";